import { Injectable } from '@angular/core';

@Injectable()
export class MovebankRestMockService {
  get() {}

  create() {}
}
